import { render } from "./InjuryUnitEdit.vue?vue&type=template&id=7d2093df&scoped=true"
import script from "./InjuryUnitEdit.vue?vue&type=script&lang=js"
export * from "./InjuryUnitEdit.vue?vue&type=script&lang=js"

import "./InjuryUnitEdit.vue?vue&type=style&index=0&id=7d2093df&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d2093df"]])

export default __exports__